// extracted by mini-css-extract-plugin
export default {"tenantLogo":"D1qIE___NotableTenants-module__tenantLogo","title":"vYhE0___NotableTenants-module__title","container":"ZNkgt___NotableTenants-module__container"};